import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';

import { bindAll } from '@bibliocommons/utils-react';
import Loader from 'app/components/shared/Loader/Loader';
import BaseCarousel from '@bibliocommons/carousel-base';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import { IconWithBackground, Clock, Carets } from '@bibliocommons/deprecated-base-icons';

import { CONTENT_PROVIDER_IDS } from 'app/constants/BibConstants';
import { getRecommendationProviderDisplayName } from 'app/helpers/bib/bibHelpers';
import { recommendationShape } from 'app/shapes/search';
import RecommendationItem from './RecommendationItem';

import './styles/Recommendations.scss';

class Recommendations extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false
    };

    bindAll(this);
  }

  componentDidMount() {
    /** Need that in test to make sure that component got rendered properly * */
  }

  handleClick() {
    if (!this.props.loaded) {
      this.props.getRecommendations(this.props.itemId);
    }

    this.setState(state => ({ isExpanded: !state.isExpanded }));
  }

  renderSlider() {
    const { zeroResults, loaded, recommendations } = this.props;
    if (loaded && zeroResults) {
      return (
        <FormattedMessage id="while_you_wait_empty">
          {message => <p className="empty-result">{message}</p>}
        </FormattedMessage>
      );
    }

    if (loaded && !zeroResults) {
      return (
        <BaseCarousel.BaseCarousel
          buttonBackgroundColor="#f9f9f9"
          breakpointSettings={{
            10000: {
              useTouchArrows: false,
              itemsPerPage: 5,
              partiallyShowOffscreenItems: false,
              showDots: true,
              gutterSize: '25px'
            },
            787: {
              useTouchArrows: false,
              itemsPerPage: 4,
              partiallyShowOffscreenItems: false,
              showDots: true,
              gutterSize: '25px'
            },
            610: {
              useTouchArrows: false,
              itemsPerPage: 3,
              partiallyShowOffscreenItems: false,
              showDots: true,
              gutterSize: '25px'
            },
            525: {
              useTouchArrows: false,
              itemsPerPage: 2,
              partiallyShowOffscreenItems: false,
              showDots: true,
              gutterSize: '25px'
            }
          }}
          titleData={{}}
        >
          {recommendations.map(recommendation => (
            <RecommendationItem
              key={recommendation.id}
              recommendation={recommendation}
              recommendationType={this.props.type}
            />
          ))}
        </BaseCarousel.BaseCarousel>
      );
    }

    return <FormattedMessage id="while_you_wait_loading">{message => <Loader message={message} />}</FormattedMessage>;
  }

  renderSourceMessage() {
    const { intl, zeroResults } = this.props;
    if (this.state.isExpanded && !zeroResults) {
      const defaultProviderName = intl.formatMessage({
        defaultMessage: 'a third party',
        id: 'recommendations.third_party_provider'
      });

      return (
        <FormattedMessage
          id="recommendations_powered_by"
          values={{ provider: getRecommendationProviderDisplayName(this.props.type, defaultProviderName) }}
        >
          {message => <small className="recommendation-source">{message}</small>}
        </FormattedMessage>
      );
    }
    return null;
  }

  render() {
    const { isExpanded } = this.state;
    const recommendationsClass = cn('cp-recommendations', {
      'is-expanded': isExpanded
    });
    return (
      <div className={recommendationsClass}>
        {/* eslint-disable-next-line @bibliocommons/bibliocommons/dataKey */}
        <TextButton className="while-you-wait-toggle" data-test-id="whileyouwait-toggle" handleClick={this.handleClick}>
          <IconWithBackground bgColor="#cc441e" icon={<Clock />}>
            <FormattedMessage id="while_you_wait_title" />
            <Carets.Down
              className={cn('resource-expand-icon', {
                rot90: !this.state.isExpanded
              })}
            />
          </IconWithBackground>
          {this.props.loaded && this.renderSourceMessage()}
        </TextButton>
        {this.state.isExpanded && this.renderSlider()}
      </div>
    );
  }
}

Recommendations.propTypes = {
  getRecommendations: PropTypes.func.isRequired,
  itemId: PropTypes.string.isRequired,
  recommendations: PropTypes.arrayOf(recommendationShape).isRequired,
  type: PropTypes.oneOf(Object.values(CONTENT_PROVIDER_IDS)),
  loaded: PropTypes.bool,
  zeroResults: PropTypes.bool
};

export default injectIntl(Recommendations);
